import { atom } from "jotai";

export const carpetasLegajos = atom([]);